<template>
  <div class="imgBox">
    <div class="pic-404">
      <img class="pic-404__parent" src="../../assets/404_images/404.png" alt="404" />
    </div>
    <div class="bullshit">
      <div class="bullTitle bullTitle404">404</div>
      <div class="bullMess">
        <p style="margin-bottom:16px;">抱歉，您访问的页面不存在</p>
        <p>
          <el-button type="primary" @click="goBack">返回首页</el-button>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goBack() {
      this.$router.push({
        path: '/'
      });
    }
  }
};
</script>

<style scoped></style>
